export type BillingsCargoTaxiUpdateParamsBillingNode = {
  uuid: string;
  nodeUuid: string;
  checkoutEventUuid?: string;
  lat: number;
  lon: number;
  description: string;
  editableCoordinated: boolean;
  checkoutDate?: Date;
  plannedDate?: Date;
  orderUuid?: string;
  distance: number;
  plannedDistance: number;
  haltingTime: number;
  highwayCharge: number;
  allowCharge: boolean;
};

export enum BillingsCargoTaxiUpdateParamsBillingContributionType {
  BASE_AMOUNT = "BASE_AMOUNT",
  CHARGE_HALTING = "CHARGE_HALTING",
  DISCOUNT_OPTIMIZATION = "DISCOUNT_OPTIMIZATION",
  DISCOUNT_BEING_LATE = "DISCOUNT_BEING_LATE",
  DISCOUNT_INCOMPATIBLE_CAR = "DISCOUNT_INCOMPATIBLE_CAR",
  DISCOUNT_OTHER = "DISCOUNT_OTHER",
  CONTRACT_CORRECTION_PERCENTAGE = "CONTRACT_CORRECTION_PERCENTAGE",
}

export type BillingsCargoTaxiUpdateParamsBillingContributionBaseAmount = {
  type: BillingsCargoTaxiUpdateParamsBillingContributionType.BASE_AMOUNT;
  comment?: string;
  distance: number;
  rate: number;
};

export type BillingsCargoTaxiUpdateParamsBillingContributionChargeHaltings = {
  type: BillingsCargoTaxiUpdateParamsBillingContributionType.CHARGE_HALTING;
  comment?: string;
  distance: number;
  amount: number;
};

export type BillingsCargoTaxiUpdateParamsBillingContributionContractCorrectionPercentage =
  {
    type: BillingsCargoTaxiUpdateParamsBillingContributionType.CONTRACT_CORRECTION_PERCENTAGE;
    comment?: string;
    percentage: number;
    amount: number;
  };

export type BillingsCargoTaxiUpdateParamsBillingContributionDiscountOptimization =
  {
    type: BillingsCargoTaxiUpdateParamsBillingContributionType.DISCOUNT_OPTIMIZATION;
    comment?: string;
    amount: number;
  };

export type BillingsCargoTaxiUpdateParamsBillingContributionDiscountBeingLate =
  {
    type: BillingsCargoTaxiUpdateParamsBillingContributionType.DISCOUNT_BEING_LATE;
    comment?: string;
    amount: number;
  };

export type BillingsCargoTaxiUpdateParamsBillingContributionDiscountIncompatibleCar =
  {
    type: BillingsCargoTaxiUpdateParamsBillingContributionType.DISCOUNT_INCOMPATIBLE_CAR;
    comment?: string;
    amount: number;
  };

export type BillingsCargoTaxiUpdateParamsBillingContributionDiscountOther = {
  type: BillingsCargoTaxiUpdateParamsBillingContributionType.DISCOUNT_OTHER;
  comment?: string;
  amount: number;
};

export type BillingsCargoTaxiUpdateParamsBillingContribution =
  | BillingsCargoTaxiUpdateParamsBillingContributionBaseAmount
  | BillingsCargoTaxiUpdateParamsBillingContributionChargeHaltings
  | BillingsCargoTaxiUpdateParamsBillingContributionContractCorrectionPercentage
  | BillingsCargoTaxiUpdateParamsBillingContributionDiscountOptimization
  | BillingsCargoTaxiUpdateParamsBillingContributionDiscountBeingLate
  | BillingsCargoTaxiUpdateParamsBillingContributionDiscountIncompatibleCar
  | BillingsCargoTaxiUpdateParamsBillingContributionDiscountOther;

export type BillingsCargoTaxiUpdateParamsBody = {
  billingNodes: BillingsCargoTaxiUpdateParamsBillingNode[];
  billingsContributions: BillingsCargoTaxiUpdateParamsBillingContribution[];
};

type BillingsCargoTaxiUpdateParams = {
  billingUuid: string;
  billingNodes: BillingsCargoTaxiUpdateParamsBillingNode[];
  billingContributions: BillingsCargoTaxiUpdateParamsBillingContribution[];
};

export default BillingsCargoTaxiUpdateParams;
